// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: relative;
}

.popup-content {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 20px;
  width: 680px;
  height: 130px;
  position: absolute;
  margin: 32px;
  top: -144px;
  left: 20px;
  color: #000;
  background-color: #fff;
  box-shadow: 0px 0px 16px 4px rgba(0, 0, 0, 0.04), 0px 33px 24px -17px rgba(0, 0, 0, 0.12);
}

.form-control-select {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 8px !important;
}

body .form-control-select .css-13cymwt-control {
  border: none;
  border-radius: 12px !important;
}

body .form-control-select .css-qbdosj-Input,
.css-1dimb5e-singleValue {
  color: #232627;
  font-weight: 600;
}

.tone-options p {
  color: #919597;
  font-weight: 500;
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Popup/popup.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,yFAAA;AACF;;AAEA;EACE,2CAAA;EACA,6BAAA;AACF;;AAEA;EACE,YAAA;EACA,8BAAA;AACF;;AAGA;;EAEE,cAAA;EACA,gBAAA;AAAF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAFF","sourcesContent":[".popup {\n  position: relative;\n}\n\n.popup-content {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n  padding: 20px;\n  width: 680px;\n  height: 130px;\n  position: absolute;\n  margin: 32px;\n  top: -144px;\n  left: 20px;\n  color: #000;\n  background-color: #fff;\n  box-shadow: 0px 0px 16px 4px rgba(0, 0, 0, 0.04), 0px 33px 24px -17px rgba(0, 0, 0, 0.12);\n}\n\n.form-control-select {\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 8px !important;\n}\n\nbody .form-control-select .css-13cymwt-control {\n  border: none;\n  border-radius: 12px !important;\n\n}\n\nbody .form-control-select .css-qbdosj-Input,\n.css-1dimb5e-singleValue {\n  color: #232627;\n  font-weight: 600;\n}\n\n.tone-options {}\n\n.tone-options p {\n  color: #919597;\n  font-weight: 500;\n  font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
